import React, { useEffect } from 'react';
// Store
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { checkIsLoading } from 'src/utils/types/statuses';
import {
  checkCanLoadExpertises,
  getExpertisesForSelect,
} from 'src/store/lists/expertises/helpers';
import { fetchExpertises } from 'src/store/lists/expertises/asyncThunk';
// UI
import {
  BaseMultiSelect,
  PBaseMultiSelect,
} from '../../../common/selects/BaseMultiSelect/BaseMultiSelect';

type PExpertisesMultiSelect = PBaseMultiSelect;

export const ExpertisesMultiSelect: React.FC<PExpertisesMultiSelect> = (
  props,
) => {
  const { ...otherProps } = props;

  const dispatch = useDispatch();
  useEffect(() => {
    checkCanLoadExpertises(() => dispatch(fetchExpertises()));
  }, [dispatch]);

  const { status } = useSelector((state: RootState) => state.expertises);
  const countriesOptions = useSelector(getExpertisesForSelect);

  return (
    <BaseMultiSelect
      options={countriesOptions}
      label="Areas of expertise"
      loading={checkIsLoading(status)}
      {...otherProps}
    />
  );
};
